import React, {FC, memo} from 'react';


// import messages from './messages';
import { SingleEvent } from '../../../../models/eventItem';
import styled from 'styled-components';
import H3 from '../../../Headings/H3';
import colors from '../../../../config/colors';
import parse from 'html-react-parser';
import P from '../../../Paragraph';
import { formatDatefromString, formatTime } from '../../../../utils/date';

interface ISimilarEvents {
    item: SingleEvent;
}

const Similar: FC<ISimilarEvents> = ({item}) => {

    return (
        item ?
            <SimilarEventCard>
                <H3>{item.title}</H3>
                <Description>{parse(`${item.description}`)}</Description>
                <P>Mesto održavanja: <span>{item.availability === 'online' ? 'Online' : null || item.availability === 'offline' ? item.event_place? item.event_place : item.address+', '+item.city : null}</span></P>
                {item.date ? <P>Datum održavanja: <span>{formatDatefromString(item.date)}</span></P> : null}
                {item.start_time || item.end_time ?
                    <P>Vreme održavanja:: <span>{item.start_time && item.end_time ? formatTime(item.start_time) + ' - ' + formatTime(item.end_time) : item.start_time ? formatTime(item.start_time) : item.end_time ? formatTime(item.end_time) : null}</span></P>
                : null}
                  {item.type ?
                    <P>Vrsta događaja: <span>{item.type}</span></P>
                : null}
            </SimilarEventCard>
        : null
    )
}

const SimilarEventCard = styled.div`
    background: ${colors.WHITE};
    padding: 15px 20px;
    margin: 20px 0;
    h3 {
        font-size: 20px;
    }
    p {
        margin-bottom: 10px;
    }
    span {
        font-family: "Gilroy-Medium";
        color: ${colors.BLACK};
    }
    &:hover {
        background: ${colors.PRIMARY_PURPLE};
        transition: all 100ms ease-in-out;
        h3, p, span {
            color: ${colors.WHITE};
        }
    }
`;

const Description = styled(P)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export default memo(Similar);